import { render, staticRenderFns } from "./Voyages.vue?vue&type=template&id=48438659&scoped=true&"
import script from "./Voyages.vue?vue&type=script&lang=js&"
export * from "./Voyages.vue?vue&type=script&lang=js&"
import style0 from "./Voyages.vue?vue&type=style&index=0&id=48438659&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48438659",
  null
  
)

export default component.exports